export default "__VITE_ASSET__CiWKo6Hh__"